import { component } from "picoapp";
import { klaviyoSubscribe } from "@root/tablescape/utilities";
import { isUK } from "../lib/customerLocation";

export default component((node, ctx) => {
  const creditsToggle = node.querySelector(".js-credits-toggle");
  const credits = node.querySelector(".js-credits");
  const creditsCover = node.querySelector(".js-credits-cover");

  if (creditsCover) {
    creditsCover.addEventListener("click", (e) => {
      e.preventDefault();
      credits.classList.remove("active");
      creditsCover.classList.remove("active");
    });
  }

  if (creditsToggle) {
    creditsToggle.addEventListener("click", (e) => {
      e.preventDefault();
      credits.classList.toggle("active");
      creditsCover.classList.add("active");
    });
  }

  const form = node.querySelector(".footer__form");
  if (!form) {
    return;
  }

  const listId = form.getAttribute("data-list-id");

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    const email = e.target.elements.email.value;

    let body = {
      customSource: "footer email form",
    };

    if (isUK()) {
      body = {
        $fields: ["$consent"],
        $consent: "email",
      };
    }

    if (!email) {
      return;
    }

    klaviyoSubscribe(listId, email, body).then((res) => {
      if (res?.ok) {
        form.classList.add("was-successful");
        form.reset();
      }

      setTimeout(() => {
        // form.classList.remove('was-successful')
      }, 2000);
    });
  });
});
